<template>
	<div>
		<div class="mt-4 container-fluid">
			<nav class="navbar navbar-expand-lg navbar-light">
			 	<h1 class="h3 mb-0 text-gray-800 mr-4 mb-2">
					Relatório - Clientes
			  	</h1>
			  	<button 
					class="navbar-toggler" 
					type="button" 
					data-toggle="collapse" 
					data-target="#navbarSupportedContent" 
					aria-controls="navbarSupportedContent" 
					aria-expanded="false" 
					aria-label="Toggle navigation">
			    	<span class="navbar-toggler-icon"></span>
			  	</button>
			  	<div class="collapse navbar-collapse mt-4" id="navbarSupportedContent">
			  		<div class="form-row">
						<div class="form-group col-md-12">
							<input-date 
								time="1000"
								@date="setDate">
							</input-date>
						</div>
					</div>
			  	</div>
			</nav>
			<relatorio-clientes-totais 
				:key="relatorioClienteTotaisKey"
				v-if="date"
				:date="date">
			</relatorio-clientes-totais>
			<relatorio-clientes-rank 
				:key="relatorioClienteRankKey"
				v-if="date"
				:date="date">
			</relatorio-clientes-rank>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				date: '',
				relatorioClienteTotaisKey: 1,
				relatorioClienteRankKey: 2
			}
		},
		methods: {
			setDate(date){
				this.date = date;
				this.reload();
			},
			reload(){
				this.relatorioClienteTotaisKey += 1;
				this.relatorioClienteRankKey += 1;
			}
		}
	}
</script>